import Marionette from "../../../src/shared/marionette-mustache";
import { backboneViewProperties } from "../../../src/decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { Container } from "aurelia-dependency-injection";
import { ContainerHelper } from "../../shared/helpers/container-helper";

require("../../../src/desktop/styles/statute-outline.less");
const template = require<string>("./fulltext-statute-outline.html");

const dom = {
    SECTION_NAME: ".statute-document-link"
};

@backboneViewProperties({
    tagName: "div",
    className: "statute-outline",
    template
})
export class FulltextStatuteOutlineView extends Marionette.ItemView<Backbone.Model> {
    public appEvents: Backbone.Events;

    constructor(options?: Backbone.ViewOptions<Backbone.Model>) {
        super(options);

        this.appEvents = ContainerHelper.Events;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click ${dom.SECTION_NAME}`] = (e) => this.onClickDocumentLink(e);

        return events;
    }
    public onClickDocumentLink(e: JQueryEventObject) {
        e.preventDefault();
        e.stopPropagation();
        const t = $(e.currentTarget);
        this.appEvents.trigger(AppEvents.ViewStatuteOutline, t.prop("pathname"));
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/fulltext-statute-outline.ts